import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Notifications: 'Notifications',
  NotificationType: 'Notification type',
  CreatedOn: 'Created on',
  Message: 'Message',
  Relation: 'Relation',
  CreatedDateFrom: 'Created on from',
  CreatedDateTo: 'Created on until',
  Today: 'Today',
  ThisWeek: 'This week',
  ThisMonth: 'This month',
  All: 'All',
  ShowHistory: 'Show history',
  MarkAsRead: 'Mark as read',
  Delete: 'Delete',
  Notification: 'Notification',
  DownloadFile: 'Download file',
  ResetFilters: 'Reset filters',
  SharedWithMe: 'Shared with me',

  OpenNotificationSettings: 'Open notification settings',
  NotificationSettings: 'Notification settings',
  NotificationTypeSettings: 'Notification type settings',
  NotificationTypeSettingsInfo: 'Choose which types you want to receive notitications for',
  ReceiveNotificationsForAllRelations: 'Receive notifications for all relations',
  OrOnlyIfYouAreAssignedAs: 'Or only if you are assigned as',
  AssignedBy: 'Assigned by',
  CompletedBy: 'Completed by',
  ReceiveNotificationsForAllRelationsOfCompanies:
    'Receive notifications for all relations of these companies (empty means all companies)',
});

export default messages;
